import { ActionIcon, Tooltip } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface CopyPhoneButtonProps {
  // Read lazily on click, since request forms are uncontrolled and props would be stale.
  getValue: () => string | undefined;
}

export const CopyPhoneButton = ({ getValue }: CopyPhoneButtonProps) => {
  const { t } = useTranslation();
  const clipboard = useClipboard({ timeout: 1200 });

  const handleCopy = () => {
    const value = getValue()?.trim();
    if (!value || value.replace(/\D/g, "").length === 0) return;
    clipboard.copy(value);
  };

  return (
    <Tooltip
      label={clipboard.copied ? t("dashboard.call.actions.copied") : t("dashboard.call.actions.copy")}
      withArrow
    >
      <ActionIcon
        aria-label={t("dashboard.call.actions.copy")}
        onClick={handleCopy}
        variant="subtle"
        color="gray"
        size="sm"
      >
        {clipboard.copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
      </ActionIcon>
    </Tooltip>
  );
};
